import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: []
})
export class ErrorComponent {
  @Input()
  formCtrl: any;

  @Input()
  submitted: boolean = false;

  constructor() { }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/error/error.component.ts